import { render, staticRenderFns } from "./LessonElement.vue?vue&type=template&id=34f4f90e"
import script from "./LessonElement.vue?vue&type=script&lang=js"
export * from "./LessonElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports